export default __webpack_public_path__ + "static/media/DA_classic.1eaeb707.jpg";